// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { navigation } from './frontend/navigation.js'

( (navigation) => {

    var $ = require( "jquery" );

    const site = {

        bootstrap: () => {

            site.initSlider()
            site.initScrollTo()
            site.scrollPosition(),
            site.scrollTopBtn(),
            // site.initProductRequestForm()
            site.initCircleAnimation()
            // site.initAvailabilityCheck()
            navigation.initToggle()
            /* site.initRequestFormQuery() */
        },

        initSlider: () => {

            const swiper = new Swiper('.application-slider', {

                modules: [Navigation, Pagination],

                // Optional parameters
                lazy: false,
                loop: true,
                pagination: true,
                slidesPerView: 1,
                spaceBetween: 0,

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                breakpoints: {
                    639: {
                        centeredSlides: true,
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    1100: {
                        centeredSlides: true,
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    1366: {
                        centeredSlides: true,
                        slidesPerView: 4,
                        spaceBetween: 20,
                    },
                    1536: {
                        centeredSlides: true,
                        initialSlide: 2,
                        slidesPerView: 4,
                        spaceBetween: 40,
                    },
                    2000: {
                        centeredSlides: true,
                        slidesPerView: 6,
                        spaceBetween: 40,
                    },
                },
                
            });

        },

        initScrollTo: () => {

            // Scroll-to-top nur anzeigen, wenn der Inhalt größer als der Bildschirm ist
            $(".js-scroll-to-top").toggle( $("body").height() > $(window).height() );

            // Click-Handler
            $(".js-scroll-to-top").on( 'click', () => $("html, body").animate({ scrollTop: 0 }, "slow") )

        },

        /**
         * Event-Listener für das Anfrage-Formular
         */
        initProductRequestForm: () => {

            

            // Event-Listener für's Öffnen
            $("#show-product-request-form").on( 'click', function() {
                $("#product-request-form").fadeIn(800);

                // Angefragte Menge aus dem Input-Feld übernehmen und ins Feld des Formulars schreiben
                let quantity = $("[name='quantity']").val();
                $("#product-request-form .amount").html( quantity );
                
                // Wir fügen eine Klasse hinzu, um das Element auch zu erkennen, wenn es schon mal geändert wurde                
                $("input[value='{menge}'], .quantity-input", $("#product-request-form")).addClass("quantity-input").val( quantity ).trigger('change');
            })

            // Event-Listener für's Schließen
            $("#hide-product-request-form").on( 'click', function() {
                $("#product-request-form").fadeOut(400);
            })

        },

        initCircleAnimation: () => {

            const text = document.querySelector(".circular-text svg")
           
            if(text) {
             
                // Animierter Circle - nach Scrollposition
                window.addEventListener("scroll", function(){
                    text.style.transform=`rotate(${window.scrollY * 0.15}deg)`
                });
            }
        },


        /**
         * Liefert den Status des Lagerbestands und -Zulauf einer Menge
         * @return "stock" | "inlet" | "outofstock"
         */
        checkQuantityStockStatus: ( quantity ) => {

            let eventName = "quantity-stock-status";

            // Lagerbestand und Lagerzulauf aus dem data-Attribut von .availability auslesen
            let stockData = JSON.parse( atob( $('.availability').attr("data-stock") ) );

            let status = "outofstock";

             // Lagerzulauf für diese Menge vorhanden oder lagernd
             if( quantity <= stockData.stock + stockData.storage_inlet ) {
                status = "inlet";
            }

            // Menge auf Lager => "Sofort verfügbar"
            if( quantity <= stockData.stock ) {
                status = "stock";
            }    
           
            // Default: Out of stock => Rote Info
            $(document).trigger( eventName, [ status, stockData, quantity ] );

        },


        /**
         * Überprüft die Verfügbarkeit bei Eingabe der Menge und zeigt an, ob ein Produkt auf Lager ist, Lagerzulauf vorhanden ist, 
         * oder nicht verfügbar ist.
         * 
         * Je nachdem, ob das Produkt verfügbar ist, wird der "Zum Warenkorb hinzufügen"-Button bzw. der "Warenkorb aktualisieren"-Button
         * (auf der Warenkorb-Seite) (de-)aktiviert.
         */
        initAvailabilityCheck: () => {

            let quantityInputSelector = "[name='quantity'], .quantity input";
            let $quantityInput = $(quantityInputSelector);

            // Event-Listener, wenn sich der Verfügbarkeits-Status nach Eingabe ändert
            site.initAvailabilityChangeListener();

            // Verfügbarkeit inital überprüfen
            site.checkQuantityStockStatus( $quantityInput.val() );

            // Event-Listener für's Input-Feld
            $(document).on( 'change input', quantityInputSelector, function( e ) {
                e.stopPropagation();
                site.checkQuantityStockStatus( $(this).val() );
            });    


        },


        // Event-Listener, wenn sich der Verfügbarkeits-Status nach Eingabe ändert
        initAvailabilityChangeListener: () => {

            $(document).on( 'quantity-stock-status', function( event, status ) {

                // Info-Texte aktualisieren
                $( ".status", $('.availability') ).addClass( "hidden" );
                $(".status--" + status, $('.availability') ).removeClass("hidden");

                // Buttons de-/reaktivieren
                $(".single_add_to_cart_button, [name='update_cart']").prop( "disabled", ! ["stock", "inlet"].includes( status ) );

            } );
        },

        
        scrollPosition: () => {	
            console.log("scrollPosition");
            var myScrollFunc = function () {	
                var y = window.scrollY;

                if (y >= 500) {
                    document.getElementById("toTop").classList.remove("hidden");
                } else {
                    document.getElementById("toTop").classList.add("hidden");
                }
            };

            window.addEventListener("scroll", myScrollFunc);
        },

        
        scrollTopBtn: () => {	
            console.log("scrollTopBtn");
            $(function() {
                document.getElementById("toTop").onclick = function() {
                    window.scroll({
                        top: 0, 
                        left: 0, 
                        behavior: 'smooth'
                    });	
                };
            });            
        },	


/*         initRequestFormQuery: () => { 
                if (document.querySelector(".page-id-1401").classList.contains('page-id-1401')) {
                    console.log('yes');
                    let params = new URLSearchParams(window.location.search);
                    let category = params.get('category');
                    let field = document.getElementById('nf-field-47');
                    site.setInputField(category, field);
                }
        },

        setInputField: (category, field) => {
            console.log(field, category);
            if (field && category && category.length) {
                field.value = category;
            }
        } */
    };

    $(document).ready( site.bootstrap )

} )(navigation);